import React from "react";

import ColaboracionesSection from "../components/ColaboracionesSection";

const MainPage = () => {
  return (
    <ColaboracionesSection />
  );
};

export default MainPage;
